import { PAYMENT_PROVIDERS } from '@vy/types';

import { PaymentProvider } from '@vy/types';
import { withDefault } from '@vy/utils';

const paymentProviderMap: Record<PaymentProvider, string> = {
  [PAYMENT_PROVIDERS.PayPal]: 'PayPal',
  [PAYMENT_PROVIDERS.Stripe]: 'Stripe',
  [PAYMENT_PROVIDERS.Wire]: 'Wire',
  [PAYMENT_PROVIDERS.ACH]: 'ACH (Bank)',
  [PAYMENT_PROVIDERS.Vayu]: 'Vayu',
  [PAYMENT_PROVIDERS.Wallet]: 'Wallet',
  [PAYMENT_PROVIDERS.NetSuite]: 'NetSuite',
  [PAYMENT_PROVIDERS.QuickBooks]: 'QuickBooks',
  [PAYMENT_PROVIDERS.Xero]: 'Xero',
};

export function getPaymentProviderNameToDisplay(paymentProvider: PaymentProvider | string) {
  const displayValue = withDefault(paymentProviderMap[paymentProvider as PaymentProvider], paymentProvider);

  return displayValue;
}
